import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { CSSProperties } from 'react';

// export const StyledTableCell = styled(TableCell)(({ theme }) => ({
//     [`&.${tableCellClasses.head}`]: {
//       backgroundColor: theme.palette.common.black,
//       color: theme.palette.common.white,
//       textAlign: "center",
//       // width: "60%",
//     },
//     [`&.${tableCellClasses.body}`]: {
//       fontSize: 14,
//       textAlign: "center",
//       // width: "60%",
//     },
//   }));

//   export const StyledTableRow = styled(TableRow)(({ theme }) => ({
//     "&:nth-of-type(odd)": {
//       backgroundColor: theme.palette.action.hover,
//     },
//     "&:last-child td, &:last-child th": {
//       border: 0,
//     },
//   }));

// export const toolTipContentStyle: CSSProperties = {
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
// };

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        textAlign: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 3
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        textAlign: 'center'
    }
}));

// First column ("Parkovací místo") stays visible while scrolling horizontally.
export const stickyFirstColumnStyle = {
    position: 'sticky' as const,
    left: 0,
    zIndex: 2,
    backgroundColor: '#fff'
};

// Top-left corner cell needs to stay pinned on both axes, above every other sticky cell.
export const stickyCornerStyle = {
    position: 'sticky' as const,
    left: 0,
    zIndex: 4
};

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
    },
    '&:last-child td, &:last-child th': {
        border: 0
    }
}));

export const toolTipContentStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
};
